module.exports = __webpack_public_path__ + "media/images/inspecHomesLogo-94a04788.jpeg";